import { FilterOption } from "../common/components/filterPopover/FilterPopover.types.ts";
import { FilterOperatorUi } from "@common/api/filterTypes.ts";
import { ListFilter, ListFilterOperator } from "@common/api/filterTypes.ts";
import { hasFilterValue } from "@common/components/filterBar/filterPinning.ts";

export interface TaskFilterRequest {
    groupEntityIds?: ListFilter<string>;
    showOnlyMine?: boolean;
    months?: ListFilter<number>;
    taskIds?: ListFilter<string>;
    annualWheelActivityIds?: ListFilter<string>;
    frameworkIds?: ListFilter<string>;
    responsibleIds?: ListFilter<string>;
    assigneeIds?: ListFilter<string>;
    businessAreaIds?: ListFilter<string>;
    taskStatus?: ListFilter<number>;
    areaIds?: ListFilter<string>;
    priorities?: ListFilter<number>;
    taskType?: ListFilter<string>;
    generalTypes?: ListFilter<number>;
    contractIds?: ListFilter<string>;
    relationTypes?: ListFilter<number>;
    relatedEntityIds?: ListFilter<string>;
    tagIds?: ListFilter<string>;
    overdueTasks?: boolean;
    approachingDeadlineAndOverdueTasks?: boolean;
    searchText?: string;
}

export interface TaskTableRequest {
    filter: TaskFilterRequest;
    year: number;
}

export const TASK_FILTER_ID_TO_BACKEND_PROPERTY: Record<string, string> = {
    "show-only-mine": "showOnlyMine",
    "group-entity-ids": "groupEntityIds",
    months: "months",
    "task-ids": "taskIds",
    "activity-ids": "annualWheelActivityIds",
    "framework-ids": "frameworkIds",
    responsible: "responsibleIds",
    "assignee-ids": "assigneeIds",
    "business-area-ids": "businessAreaIds",
    "task-status": "taskStatus",
    areas: "areaIds",
    priorities: "priorities",
    "task-type": "taskType",
    "general-types": "generalTypes",
    "contract-ids": "contractIds",
    "relation-types": "relationTypes",
    "related-entities": "relatedEntityIds",
    "tag-ids": "tagIds",
    "overdue-tasks": "overdueTasks",
    "approaching-and-overdue": "approachingDeadlineAndOverdueTasks",
};

export function transformTaskFilterOptionsToBackend(filterOptions: FilterOption[]): TaskFilterRequest {
    const result: TaskFilterRequest = {};

    filterOptions.forEach((option) => {
        if (!hasFilterValue(option.value)) {
            return;
        }

        const backendProperty = TASK_FILTER_ID_TO_BACKEND_PROPERTY[option.id];
        if (!backendProperty) return;

        switch (backendProperty) {
            case "showOnlyMine":
            case "overdueTasks":
            case "approachingDeadlineAndOverdueTasks":
                (result as Record<string, unknown>)[backendProperty] = option.value as boolean;
                break;

            case "months":
            case "taskStatus":
            case "priorities":
            case "generalTypes":
            case "relationTypes":
                if (Array.isArray(option.value)) {
                    (result as Record<string, unknown>)[backendProperty] = {
                        value: option.value.map(Number),
                        filterOperator: option.filterOperator === FilterOperatorUi.Negative ? ListFilterOperator.NotIn : ListFilterOperator.In,
                    };
                }
                break;

            case "groupEntityIds":
            case "taskIds":
            case "annualWheelActivityIds":
            case "frameworkIds":
            case "responsibleIds":
            case "assigneeIds":
            case "businessAreaIds":
            case "areaIds":
            case "contractIds":
            case "relatedEntityIds":
            case "tagIds":
            case "taskType":
                if (Array.isArray(option.value)) {
                    (result as Record<string, unknown>)[backendProperty] = {
                        value: option.value,
                        filterOperator: option.filterOperator === FilterOperatorUi.Negative ? ListFilterOperator.NotIn : ListFilterOperator.In,
                    };
                }
                break;
        }
    });

    return result;
}
